import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from '@/functions/Fetch.js';

const enrollmentsReducer = createAsyncReducer({
    name: 'enrollments',
    initialState: {
        currentEnrollments: {},
        currentEnrollmentsLoading: false,
        records: {},
        loading: false,
        errorMessage: ''
    },
    reducers: (create) => ({
        create: create.asyncThunk(
            async ({ certification_id }) => {
                return await Fetch.post(Routes.ajax_enrollments_path({ certification_id }));
            },
            {
                pending: (state, action) => {
                    state.currentEnrollmentsLoading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.currentEnrollmentsLoading = false;
                    if (action.payload) {
                        state.currentEnrollments = { ...state.currentEnrollments, [action.payload.id]: action.payload };
                        state.records[action.payload.id] = action.payload;
                    }
                },
                rejected: (state, action) => {
                    const { message } = action.error;
                    state.errorMessage = message;
                    state.currentEnrollmentsLoading = false;
                }
            }
        ),
        loadCurrentEnrollments: create.asyncThunk(
            async () => {
                return await Fetch.get(Routes.ajax_enrollments_path());
            },
            {
                pending: (state, action) => {
                    state.currentEnrollmentsLoading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.currentEnrollmentsLoading = false;
                    if (action.payload) {
                        state.currentEnrollments = { ...state.currentEnrollments, ...action.payload };
                        state.records = { ...state.records, ...action.payload };
                    }
                },
                rejected: (state, action) => {
                    const { message } = action.error;
                    state.errorMessage = message;
                    state.currentEnrollmentsLoading = false;
                }
            }
        )
    })
});

export default enrollmentsReducer;